/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2025-07-14 10:11:08
 * @LastEditors: linxi
 * @LastEditTime: 2025-08-07 13:49:54
 */
import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  Modal,
  notification,
  Popover,
  Row,
  Select,
} from 'antd'
import { useDispatch } from 'react-redux'
import { RootDispatch } from '../../../app/store'
import React, { useContext, useEffect, useState } from 'react'
import { unwrapResult } from '@reduxjs/toolkit'
import moment from 'moment'
import { getTrainingRecordListAsync } from '../TIManagement/TIManagementSlice'
import { EditableList } from '../../../compnents/list/EditableList'
import { ThemeContext } from '../../../theme/ThemeContext'
import { DetailColumns } from './column'
import styles from './TrainingRecord.module.css'

export const DetailModal = (props: {
  editTenantId?: any
  id?: any
  isModalVisible: boolean
  onOk: () => void
  onCancel: () => void
}) => {
  const [form] = Form.useForm()

  const dispatch = useDispatch<RootDispatch>()

  const theme = useContext(ThemeContext)

  const [total, setTotal] = useState<any>()

  const [data, setData] = useState<any[]>([])

  const [queries, setQueries] = useState<any>({
    current: 1,
    size: 10000,
  })

  const [pageLoading, setPageLoading] = useState(false) // 表格 loading

  const getDetail = () => {
    dispatch(
      getTrainingRecordListAsync({
        ...queries,
        trainingId: props?.id,
        tenantId: props?.editTenantId,
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        setData(res.records)
        setTotal(res.total)
      })
  }

  useEffect(() => {
    if (props.isModalVisible) {
      if (props?.id) {
        getDetail()
      }
    } else {
      form.resetFields()
    }
  }, [props.isModalVisible, props?.id])

  return (
    <>
      <Modal
        width={1000}
        title={'培训明细'}
        visible={props.isModalVisible}
        className={styles.modal}
        footer={null}
        maskClosable={true}
        destroyOnClose={false}
        onCancel={() => {
          props.onCancel()
        }}
        onOk={() => {
          props?.onOk()
        }}
      >
        <Col className={styles.content}>
          <Col
            className={styles.contentMain}
            style={{
              flex: 1,
              backgroundColor: theme.pn,
            }}
          >
            <EditableList
              scroll={{ y: '25rem' }}
              pagination={false}
              loading={pageLoading}
              page={{
                items: data,
                current: queries.current || 1,
                size: queries.size || 10,
                total: total,
              }}
              // onChangePage={(current: any, size: any) => {
              //   setQueries({
              //     ...queries,
              //     current,
              //     size,
              //   })
              // }}
              columns={DetailColumns(
                (queries.size || 10) * ((queries.current || 1) - 1)
              )}
            />
          </Col>
        </Col>
      </Modal>
    </>
  )
}
